/* eslint-ignore */
// @ts-nocheck
import React, { useEffect } from 'react';
import { RiCheckboxCircleLine } from "react-icons/ri";
import { AiOutlineArrowRight } from "react-icons/ai"



import {
  Container,
  Title,
  Text,
  ContainerInformation,
  CheckBoxContainer,
  ImgCongratulations,
  InformationWrap,
  InformationTitle,
  InformationSubTitle,
  InformationText,
  InformationSeparator,
  ButtonsWrap,
  ButtonNext,
  UllyWrap,
  UllyInformation,
} from './styles';

function TheEnd() {
  useEffect(() => {
    const timeOut = setTimeout(() => {
      return (window.location.href = '/');
    }, 10000);

    return () => clearTimeout(timeOut);
  }, []);

  return (
    <Container>
      <Title>Fim</Title>
      <Text>Seu email foi validado com sucesso!</Text>
      <ContainerInformation>
        <CheckBoxContainer>
          <RiCheckboxCircleLine size={60} />
        </CheckBoxContainer>
        <InformationWrap>
          <InformationTitle>Tudo certo, agora você já pode acessar ao portal.</InformationTitle>          
          <InformationSeparator />
          <InformationText>
            Acesse Minha Ultragraz agora mesmo e aproveite todas as facilidades
            que preparamos especialmente pra você.
          </InformationText>
        </InformationWrap>
      </ContainerInformation>
      <ButtonsWrap>
        <ButtonNext
          buttonType="primary"
          iconRight={AiOutlineArrowRight}
          onClick={() => (window.location.href = '/')}
        >
          Acessar o Portal
        </ButtonNext>
      </ButtonsWrap>
      <UllyWrap>
        <UllyInformation>
          Se precisar de ajuda, converse com a Ully, a assitente virtual da
          Ultragaz.
        </UllyInformation>
      </UllyWrap>
    </Container>
  );
}

export default TheEnd;
